/**
 * step0ConsentWording.ts — the Step-0 marketing-consent WORDING, and the
 * version id it is stored under. ONE constant, read by the one surface that
 * shows it (the Step-0 capture form) and by the specs that pin it.
 *
 * Owner repo: @thegpservice/gpsclinics-portal. Slice: Step-0 consent tick
 * (2026-09-23; server contract clinic #218).
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * ⚠️ DRAFT — NOT APPROVED. `mc-2026-09-23-step0-d1` is awaiting CTO sign-off,
 * and the box that shows it ships behind `VITE_STEP0_CONSENT_ENABLED`
 * (default OFF — see `step0MarketingConsentEnabled()` in `../config`). The
 * flag stays OFF in every environment until the sign-off is recorded here,
 * the way `consentWording.ts` records the 2026-09-14 approval of
 * `mc-2026-09-11-d1`. Approval does not change the id: the id names the
 * WORDS, never their approval state.
 * ─────────────────────────────────────────────────────────────────────────────
 *
 * WHY A SECOND WORDING AND NOT A REUSE OF `consentWording.ts`. The
 * questionnaire consent step's `mc-2026-09-11-d1` (the Result screen's until
 * 2026-09-23) is a two-channel preference (email + WhatsApp, grant and
 * withdraw); Step 0 asks ONE narrower question — email only, grant
 * only — before any assessment exists, and clinic-service stores the version
 * id with the grant. The id we send has to name the words this screen SHOWED,
 * so a screen showing different words needs its own id. Same registry rule as
 * `consentWording.ts`: a reword is a NEW id in BOTH repos, never an edit in
 * place, or the stored version describes words the patient never saw.
 *
 * GRANT-ONLY IS THE CONTRACT'S SHAPE, NOT COPY. The lead create takes
 * `marketingConsent: { email: true, wordingVersion }` or NOTHING — an unticked
 * box sends no field at all, and `email: false` is the server's 400. See
 * `LeadMarketingConsentGrant` in `../api/types`.
 *
 * VERBATIM. Rendered character for character (straight apostrophes included);
 * `step0ConsentWording.spec.ts` pins every string literally. PECR reg. 22 +
 * UK GDPR Art 7: specific, UNTICKED by default, optional in its own words,
 * and the withdraw line promises what `/preferences` and the email footer
 * deliver.
 */

/** The version id clinic-service stores against every grant made with these words. */
export const STEP0_CONSENT_WORDING_VERSION = 'mc-2026-09-23-step0-d1';

/** The words themselves. Rendered verbatim; see the header before changing any of them. */
export const STEP0_CONSENT_WORDING = {
  version: STEP0_CONSENT_WORDING_VERSION,
  intro:
    "Optional: would you like The GP Service to email you about your check and our GPS Clinics services? Saying no won't affect your check or your care.",
  email: 'Email me reminders about my check and news about GPS Clinics services.',
  withdraw:
    'You can change your mind at any time: use the link at the bottom of any of our emails, reply STOP to a WhatsApp message, or ask a member of our team.',
} as const;
